import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0145',
    ecrans: ['00-2']
});
